module.exports = __webpack_public_path__ + "static/Create_Order_Saga-f8f6ec1f4d4eb334042dade274da5e44.png";